<template>
  <!-- Pagination -->
  <div class="pagingBox black">
    <div class="paging02" style="margin-top: 20px;">
      <a @click="movePage(1)"  style="width: 20px;" class="btnFirst"><img src="@/assets/img/ico/ico_first02.png"></a>
      <a @click="movePage(1)" style="width: 20px;" class="btnPrev"><img src="@/assets/img/ico/ico_prev02.png"></a>
      <a v-for="row in pagination.end" :class="{'on' : payload.page === row}" style="width: 20px;" @click="movePage(row)" :key="'paginated' + row">{{ row }}</a>
      <a @click="movePage(pagination.end)" style="width: 20px;" class="btnNext"><img src="@/assets/img/ico/ico_next02.png"></a>
      <a @click="movePage(pagination.end)" style="width: 20px;" class="btnLast"><img src="@/assets/img/ico/ico_last02.png"></a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['pagination', 'payload', 'reqData'],
  name: "Pagination",
  methods: {
    movePage: function (data){
      this.payload.page = data;
      this.reqData(this.payload);
    },
  },
}
</script>

<style>
.paging02 a {
  width: 20px;
}

.paging02 a .on {
  border: 1px solid #da2c36;
  color: #da2c36;
}
</style>
